import { FantazFailure } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const trackError = createAction(
  '[Core/ErrorTrack] Track Error',
  props<{
    error: Error | FantazFailure;
  }>(),
);
